var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"size":"medium"},on:{"click":_vm.newRegister}},[_vm._v("\n    新規\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }